import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Routes } from '../routes';

const ProtectedRoute = ({ component: Component, render, ...rest }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) {
          return <Redirect to={Routes.Login.path} />;
        }
        
        if (render) {
          return render(props);
        }
        
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;